import React, { useState, useEffect } from 'react';
import {
  Button,
  IconButton,
  Typography,
  Grid,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  Tooltip,
  Autocomplete,
  TextField,
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useSnackbar } from 'notistack';
import { ACTIONS, MESSAGES } from '../../../shared/constants';
import DataTable from '../../../shared/data-table';
import {
  getAllProfile,
  getSelectedProfile,
  saveSelectedProfile,
  deleteSelectedProfile,
  getAllPermissions,
  saveSelectedPermissions,
  updateAllProfilesByEmployee,
  getEmployees,
  getAllAirports,
  getProfilesByEmployee,
  getApplications,
  getProfilesByApplication,
  bulkAssignProfiles
} from './logic';
//import ProfileTypeDetails from '../../Profile-type/Profile-type-detail';
import ManagementEmployeeDetail from '../../gestion/management-employee/management-employeeByProfile-Source';
import ManagementEmployeeBulkAssign from '../../gestion/management-employee/management-employeeBulkAssign';
import DeleteIcon from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import AddCircle from '@mui/icons-material/AddCircle';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ErrorSnackbar from '../../error-snackbar';
import BackDrop from '../../../shared/backdropDE';
import { getAllPermissionsByProfile } from '../../../shared/data-services/management-profile-service';
import { getUser } from '../../../shared/auth-service';
import AlertDialogQuestion from '../../alert-dialog-question';

const ManagementEmployee = () => {
  const [data, setData] = useState(null);
  const [id, setId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(null);
  const [action, setAction] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [employee, setEmployee] = useState(null);
  const [profiles, setProfiles] = useState([]);
  const [applications, setApplications] = useState([]);
  const [optionDetails, setOptionDetails] = useState(null);
  const [modalType, setModalType] = useState(null);
  const [uniquePositions, setUniquePositions] = useState([]);
  const user = getUser();
  const [loading, setLoading] = useState(true);
  const [airports, setAirports] = useState([]);
  const [selectedAirport, setSelectedAirport] = useState(0);
  const [alertQuestionOpen, setAlertQuestionOpen] = useState(false);
  const [idDelete, setIdDelete] = useState(null);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [identificationFilter, setIdentificationFilter] = useState('');
  const [dataFilter, setDataFilter] = useState([]);
  const [profileFilter, setProfileFilter] = useState(null);
  const [applicationFilter, setApplicationFilter] = useState(null);
  const [filteredProfileOptions, setFilteredProfileOptions] = useState([]);
  const [airportFilter, setAirportFilter] = useState(null);
  const searchInputRef = React.useRef(null);
  const positions = [47, 56, 95, 60, 611];
  const companyId = user.countryCode.split('-')[0];
  
  useEffect(() => {
    async function fetchData() {
      if (loading) {
        try {
          const data = await getEmployees(companyId);
          var airportsData = user.airports;

          // var position = user.employeePosition.id;
          // if (positions.includes(position)) 
          airportsData = await getAllAirports(companyId);
            
          //console.log(airportsData);
          setSelectedAirport(user.airport.id);
          //console.log('info employee');
          //console.log(data);
          setAirports(airportsData);
          const profiles = await getAllProfile(companyId);
          const applications = await getApplications(companyId);
          setLoading(false);
          setData(data);
          setProfiles(profiles);
          setApplications(applications);
        } catch (error) {
          setError(error.message);
          setLoading(false);
          setData([]);
        }
      }
    }
    fetchData();
  });

  // useEffect(() => {
  //   async function fetchRow() {
  //     if (id) {
  //       const item = await getSelectedProfile(id);
  //       setSelectedItem(item);
  //       setId(null);
  //       setShowModal(true);
  //     }
  //   }
  //   fetchRow();
  // });
  useEffect(() => {
    if (data) {
      setUniquePositions(getUniquePositions(data));
    }
  }, [data]);

  const getUniquePositions = (data) => {
    const unique = {};
    data.forEach((item) => {
      if (!unique[item.profile]) {
        unique[item.profile] = item;
      }
    });
    //console.log(unique);
    return Object.values(unique);
  };

  // Cargar perfiles al cambiar aplicación
  useEffect(() => {
    const loadProfiles = async () => {
      if (applicationFilter) {
        const filtered = await getProfilesByApplication(applicationFilter.id, companyId);
        setFilteredProfileOptions(filtered || []);
      } else {
        setFilteredProfileOptions([]);
        setProfileFilter(null);
      }
    };
    loadProfiles();
  }, [applicationFilter]);

  // Filtro reactivo
  useEffect(() => {
    if (!data) return;
    let result = data;

    if (identificationFilter) {
      const search = identificationFilter.toUpperCase();
      result = result.filter(item =>
        item.employee.employeeId.toString().toUpperCase().includes(search) ||
        `${item.employee.name} ${item.employee.lastName}`.toUpperCase().includes(search)
      );
    }

    if (applicationFilter && filteredProfileOptions.length > 0) {
      const appProfileIds = new Set(filteredProfileOptions.map(p => p.id));
      result = result.filter(item =>
        item.profiles.some(p => appProfileIds.has(p.id))
      );
    }

    if (profileFilter) {
      result = result.filter(item =>
        item.profiles.some(p => p.id === profileFilter.id)
      );
    }

    if (airportFilter) {
      result = result.filter(item =>
        item.employee.airport.id === airportFilter.id
      );
    }

    setDataFilter(result);
  }, [identificationFilter, profileFilter, applicationFilter, filteredProfileOptions, airportFilter, data]);

  const handleFilterEmployees = (value) => {
    setIdentificationFilter(value);
  };

  const handleDeleteData = async (cellValues) => {
    setAlertQuestionOpen(true);
    setIdDelete(cellValues.row.employee.employeeId);
  };

  const handleCloseAlert = () => {
    setAlertQuestionOpen(false);
    setIdDelete(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null);
    setOptionDetails(null);
    setEmployeeId(null);
    setEmployee(null);
    setAction(null);
  };


  const clearFilters = () => {
    setIdentificationFilter('');
    setDataFilter([]);
    setProfileFilter(null);
    setApplicationFilter(null);
    setFilteredProfileOptions([]);
    setAirportFilter(null);
  };

  const handleSave = async (profiles) => {
    await updateAllProfilesByEmployee(profiles, user.employeeId);
    setShowModal(false);
    setLoading(true);
    clearFilters();
    enqueueSnackbar(MESSAGES.SAVED);
  };

  const handleBulkSave = async ({ employeeIds, profiles }) => {
    await bulkAssignProfiles(employeeIds, profiles, user.employeeId);
    setShowBulkModal(false);
    setLoading(true);
    clearFilters();
    enqueueSnackbar(MESSAGES.SAVED);
  };

  const handleDelete = async (cellValues) => {
    await deleteSelectedProfile(idDelete, user.employeeId);
    setShowModal(false);
    setAlertQuestionOpen(false);
    setLoading(true);
    clearFilters();
    enqueueSnackbar(MESSAGES.DELETE);
  };

  const handleNew = async () => {
    setSelectedItem({});
    setId(null);
    setShowModal(true);
    setAction(ACTIONS.NEW);
  };

  const handleActionButton = (e, cellValues, action) => {
    e.stopPropagation();
    setId(cellValues.row.id);
    setAction(action);
  };

  const handleEdit = (e, cellValues) => {
    e.stopPropagation(); 
    //setEmployee(cellValues.row.description)
    //console.log('data de la fila');
    //console.log(cellValues.row);
    setSelectedAirport(cellValues.row.employee.airport.id)
    setEmployeeId(cellValues.row.employee.employeeId);
    fetchOptionDetails(cellValues.row.employee.employeeId); 
  }

  const fetchOptionDetails = async (employeeId) => {
    //console.log("fetchOptionDetails called with id:", profileId);
    //setLoadingOptionDetails(true);
    try {
      const details = await getProfilesByEmployee(employeeId, companyId);
      //console.log("Option detailsssss:");
      //console.log(details);
      setOptionDetails(details);
      setShowModal(true);
      setAction(ACTIONS.Edit);
    } catch (error) {
      setError(error.message);
    } finally {
    }
  };

  const columns = [
    { field: 'id', headerName: 'Código', miwidth: 100, flex: 0.2, hide: true },
    {
      field: 'airportId',
      headerName: 'Aeropuerto',
      minwidth: 50,
      flex: 0.3,
      hide: true,
      valueGetter: (params) => `${params.row.employee.airport.id || ''}`,
    },
    //{ field: 'employeeId', headerName: 'Cedula', minwidth: 350, flex: 0.3 },
    {
      field: 'employeeId',
      headerName: 'Identificación',
      minwidth: 350,
      flex: 0.3,
      valueGetter: (params) => `${params.row.employee.employeeId || ''}`,
   },
    {
        field: 'name',
        headerName: 'Nombre Completo',
        minwidth: 350,
        flex: 1,
        valueGetter: (params) => `${params.row.employee.name || ''} ${params.row.employee.lastName || ''}`,
    },
    {
        field: 'airport',
        headerName: 'Aeropuerto',
        minwidth: 350,
        flex: 0.2,align: 'center',
        valueGetter: (params) => `${params.row.employee.airport.code || ''}`,
    },
      {
        field: 'employeePosition',
        headerName: 'Cargo',
        minwidth: 350,
        flex: 1,
        valueGetter: (params) => `${params.row.employee.employeePosition.name || ''}`,
    },
    {
      field: 'profileCount',
      headerName: 'Perfiles Asignados',
      type: 'number',
      minwidth: 150,
      flex: 0.3,
      align: 'center', headerAlign: 'center',
      valueGetter: (params) => params.row.profiles.length || 0, // Asegúrate de tener disponible el conteo de perfiles en cada fila
    },
    {
      field: "Editar",
      headerName: "Editar",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => {
        return <IconButton
          color="info"
          onClick={(e) => { handleEdit(e, cellValues) }}
        >
          <Edit />
        </IconButton>;
      }
    },
    {
      field: "Borrar",
      headerName: "Borrar",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => {
        return <IconButton
          aria-label="delete"
          color="error"
          onClick={() => { handleDeleteData(cellValues) }}
        >
          <DeleteIcon />
        </IconButton>;
      }
    },
  ];

  if (loading) {
    return (
      // <Box sx={{ display: 'flex' }}>
      //     <CircularProgress />
      // </Box>
      <BackDrop />
    );
  }

  if (error) {
    return (<ErrorSnackbar message={error} />);
  }

  return (
    <>
      {showBulkModal && <ManagementEmployeeBulkAssign
        airports={airports}
        applications={applications}
        handleClose={() => setShowBulkModal(false)}
        handleSave={handleBulkSave}
      />}

      {showModal && <ManagementEmployeeDetail
        data={optionDetails}
        employeeId={employeeId}
        employee={employee}
        profiles={profiles}
        applications={applications}
        handleClose={handleCloseModal}
        handleSave={handleSave}
        airportId={selectedAirport}
        airports={airports}
        action={action}
      />}

      {alertQuestionOpen && <AlertDialogQuestion
        handlePositive={handleDelete}
        handleNegative={handleCloseAlert}
        textButtonPositive={ACTIONS.ACCEPT}
        textButtonNegative={ACTIONS.CANCEL}
        dialogContentText={MESSAGES.CONFIRM_DELETE}
        dialogTitle={""}
        open={alertQuestionOpen}
        elemento={""}
      />}

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1, mb: 1, px: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5 }}>
          <Typography variant="h5" style={{ color: '#1a3072' }} fontWeight="bold">
            Perfiles Adicionales Por <span style={{ color: '#00b0ef' }}>Empleado</span>
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <Tooltip title="Filtrar por número de documento o nombre completo">
            <FormControl sx={{ width: 240 }} variant="outlined" size="small">
              <InputLabel htmlFor="outlined-adornment-search-employee">Buscar empleado</InputLabel>
              <OutlinedInput
                id="outlined-adornment-search-employee"
                inputRef={searchInputRef}
                type="text"
                value={identificationFilter}
                onChange={(e) => {
                  setIdentificationFilter(e.target.value);
                  handleFilterEmployees(e.target.value);
                }}
                endAdornment={
                  identificationFilter
                    ? <IconButton size="small" onClick={() => setIdentificationFilter('')}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    : <SearchIcon sx={{ color: '#aaa' }} />
                }
                label="Buscar empleado"
              />
            </FormControl>
          </Tooltip>
          <Autocomplete
            size="small"
            sx={{ width: 180 }}
            options={airports}
            getOptionLabel={(o) => o.code || ''}
            isOptionEqualToValue={(o, v) => o.id === v.id}
            value={airportFilter}
            onChange={(_, newValue) => setAirportFilter(newValue)}
            renderInput={(params) => <TextField {...params} label="Aeropuerto" variant="outlined" />}
            noOptionsText="Sin resultados"
          />
          <Autocomplete
            size="small"
            sx={{ width: 200 }}
            options={applications}
            getOptionLabel={(o) => o.name || ''}
            isOptionEqualToValue={(o, v) => o.id === v.id}
            value={applicationFilter}
            onChange={(_, newValue) => setApplicationFilter(newValue)}
            renderInput={(params) => <TextField {...params} label="Aplicación" variant="outlined" />}
            noOptionsText="Sin resultados"
          />
          <Autocomplete
            size="small"
            sx={{ width: 200 }}
            options={filteredProfileOptions}
            getOptionLabel={(o) => o.description || ''}
            isOptionEqualToValue={(o, v) => o.id === v.id}
            value={profileFilter}
            disabled={!applicationFilter}
            onChange={(_, newValue) => setProfileFilter(newValue)}
            renderInput={(params) => (
              <TextField {...params} label={applicationFilter ? 'Perfil' : 'Seleccione aplicación'} variant="outlined" />
            )}
            noOptionsText="Sin resultados"
          />
          <Button
            endIcon={<AddCircle />}
            variant="contained"
            onClick={() => setShowBulkModal(true)}>
            {ACTIONS.NEW}
          </Button>
        </Box>
      </Box>
      <DataTable columns={columns} rows={!identificationFilter && !applicationFilter && !profileFilter && !airportFilter ? data : dataFilter}
        sx={{
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold',
          }
        }}/>
    </>
  );
};

export default ManagementEmployee;
